// extracted by mini-css-extract-plugin
module.exports = {"comments":"e_E","related":"e_F","breadCrumbs":"e_G","postTags":"e_H","sidebarPostNav":"e_I"};